import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../../../utils/utils";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { ActualReportingListComponent, SearchItem } from "./actualreporting-list.component";
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { Router } from "@angular/router";
import { DialogService } from "../../../../services/dialog.service";
import { CustomDialogService } from "../../../../services/customdialog.service";
import { MatDialog } from "@angular/material/dialog";
import { MatChipInputEvent } from "@angular/material/chips";
import { ToastrService } from "ngx-toastr";
import { FilterPopupComponent } from "../../shared-components/filterpopup/filterpopup.component";
import { environment } from "src/environments/environment";
import { forkJoin } from "rxjs";

@Component({
    selector: "actualreporting",
    templateUrl: './actualreporting.component.html',
    styleUrls: ['./actualreporting.component.less', '../../../../style/container-tab-list.component.less', '../../../../style/new-generic-styles.component.less'],
    standalone: false
})

export class ActualReportingComponent implements OnInit, OnDestroy {


    @ViewChild(ActualReportingListComponent) actualRepSelList: ActualReportingListComponent = {} as ActualReportingListComponent;
    isReleaseActive: boolean = false;
    releaseButtonText: string = 'Initiate Release';

    isRevokeActive: boolean = false;
    revokeButtonText: string = 'Initiate Revoke';




    title: string = '';
    isEditModeEnabled = false;
    isExcelModeEnabled = false;
    isApprovalModeEnabled = false;
    isShowAllEnabled = true;

    subscriptionManagementId: any;
    subscriptionFiscalYear: any;
    subscriptionPeriod: any;
    subscriptions: any[] = [];

    list: KpiManagement[] = [];
    @ViewChild(ActualReportingListComponent, { static: false }) listComponent!: ActualReportingListComponent;

    // Filter section
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    filter: string = ''
    isAllLoaded = false;
    waitHeader = `   -  **Please, wait until all breakdowns are properly loaded**`;
    reportingDeadlineBanner = 'Please be reminded that Data Entry/Release shall be done latest by 08th Working Date as per German calendar'
    columnsToDisplay2 = ['ItemNo', 'COL1', 'COL2', 'COL3', 'COL4', 'ValueM3', 'ValueM2', 'ValueM1', 'Value', 'TotalNexus', 'ManualAdjustment', 'Total', 'Comment', 'Budget', 'actions'];

    public isProductionEnvironment = environment.production;
    showReleaseLabel = false;

    constructor(
        public defaults: DefaultValuesService
        , private http: HttpClient
        , private dialogForm: MatDialog
        , private dialog: DialogService
        , @Inject('BASE_URL') private baseUrl: string
        , private router: Router
        , private customDialog: CustomDialogService
        , private toastrService: ToastrService

    ) {
        this.updateTitle();
    }
    
    private updateTitle() {
        this.title = `Actual ${this.isBranchReporting() ? `Branch Reporting ` : `Reporting `}(${this.defaults.managementName} - ${this.defaults.fiscalYear - 1}/${this.defaults.fiscalYear} - Period ${this.defaults.period})`;
    }


    ngOnInit() {
        this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => { this.loadInformation(true) });
        this.subscriptionFiscalYear = this.defaults.fiscalYearMessageChanges$.subscribe(() => { this.loadInformation(true) });
        this.subscriptionPeriod = this.defaults.periodMessageChanges$.subscribe(() => { this.loadInformation(true) });
        if (this.defaults.managementids.length !== 0) {
            this.loadInformation(true);
        }
    }

    ngOnDestroy() {
        this.subscriptionManagementId.unsubscribe();
        this.subscriptionFiscalYear.unsubscribe();
        this.subscriptionPeriod.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    //////////////////
    //OnClick Methods

    onClickSave() {
        // Check for incorrect hours or units values
        if (this.listComponent.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'UNITS' || x.KpiUnit?.toUpperCase() === 'HOURS')
            && x.KpiValue.indexOf('.00') < 0).length > 0) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect value provided with decimals for a Units or Hours KPI.' } });
            return;
        }
        // Check for incorrect decimal value
        if (this.listComponent.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'DECIMAL')
            && this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits) === false).length > 0) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect decimal value provided' } });
            return;
        }
        // Check for incorrect currency values based on local currency
        if (this.listComponent.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'VALUES' || x.KpiUnit?.toUpperCase() === 'VALUE LC')
            && this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits) === false).length > 0) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect currency value provided.' } });
            return;
        }

        var wasAnyUpdate = this.listComponent.updatedItems.length > 0 || this.listComponent.updatedNexusItems.length > 0


        this.listComponent.updatedItems = this.listComponent.updatedItems.filter(x => x.KpiValue !== 'NaN');
        this.listComponent.updatedNexusItems = this.listComponent.updatedNexusItems.filter(x => x.ManualAdjustment !== 'NaN');

        const valueItems = this.listComponent.updatedItems;
        const nexusItems = this.listComponent.updatedNexusItems;

        const requests: any = [];
        if (valueItems.length > 0) {
            requests.push(this.http.post<any[]>(this.baseUrl + "api/KPIManagement", valueItems ));
        }
        if (nexusItems.length > 0) {
            requests.push(this.http.post<any[]>(this.baseUrl + "api/KPIManagement/actualNexusValues", nexusItems));
        }

        if (requests.length === 0) {
            this.isEditModeEnabled = false;
            if (wasAnyUpdate)
                this.loadInformation();
            return;
        }

        forkJoin(requests).subscribe({
            next: () => {
                this.loadInformation();
                this.toastrService.success('Kpi values were updated successfully!');
                this.isEditModeEnabled = false;
            },
            error: (error) => {
                this.dialog.showErrorDialog(error);
            }
        });
    }

    isCorrectCurrencyValue(value: string, decimalDigits: number) {
        const dotIndex = value.indexOf('.');
        const colonIndex = value.indexOf(',');
        if (dotIndex === -1 && colonIndex === -1) {
            return true;
        }

        const maxSymbol = Math.max(dotIndex, colonIndex);
        if (maxSymbol === -1 || maxSymbol === value.length - 1) {
            return true;
        }
        return value.length - maxSymbol - 1 <= decimalDigits;
    }

    onClickEdit() {
        if (this.isEditModeEnabled === true) {
            this.isEditModeEnabled = false
            if (this.listComponent.updatedItems.length > 0) {
                this.loadInformation()
            }
        }
        else {
            this.isEditModeEnabled = true
        }
    }

    onClickShowAllButton() {
        if (this.isShowAllEnabled === false) {
            this.isShowAllEnabled = true
        }
        else {
            this.isShowAllEnabled = false
        }
    }

    onClickReleaseMode() {
        var selectedRows = this.actualRepSelList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []

        this.customDialog.openConfirm({
            title: "Release Kpi values",
            message: `Do you want to release all populated values which are still pending? Please note that you cannot edit any values after the release!. `,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                const nexusItems = selectedRows.filter(item => this.hasNexusData(item));
                const kpiItems = selectedRows.filter(item => !this.hasNexusData(item));

                const hasSelectedItems = selectedRows.length > 0;
                const shouldCallNexus = !hasSelectedItems || nexusItems.length > 0;
                const shouldCallKpi = !hasSelectedItems || kpiItems.length > 0;

                let completedCalls = 0;
                let hasFailed = false;
                const totalCalls = (shouldCallNexus ? 1 : 0) + (shouldCallKpi ? 1 : 0);


                const handleCompletion = (succeeded: boolean) => {
                    completedCalls++;
                    hasFailed = hasFailed || !succeeded;
                    if (completedCalls === totalCalls) {
                        this.loadInformation();
                        if (hasFailed) {
                            this.toastrService.error('Kpi values could not be released. Please, contact with administrator');
                        } else {
                            this.toastrService.success('Kpi values were released successfully!');
                            if (!this.hideSections())
                                this.toggleRelease();
                        }
                    }
                };

                if (shouldCallKpi) {
                    Utils.httpReleaseKpiDefinitions(
                        this.http,
                        this.baseUrl,
                        hasSelectedItems ? kpiItems : [],
                        { isActual: true, oplyearly: false, isBranchReporting: this.isBranchReporting() },
                        this,
                        function (tthis: ActualReportingComponent) {
                            handleCompletion(true);
                        },
                        function (tthis: ActualReportingComponent) {
                            handleCompletion(false);
                        }
                    );
                }

                if (shouldCallNexus) {
                    Utils.httpReleaseKpiNexusValues(
                        this.http,
                        this.baseUrl,
                        hasSelectedItems ? nexusItems : [],
                        this.isBranchReporting(),
                        this,
                        function (tthis: ActualReportingComponent, result: boolean) {
                            handleCompletion(result !== false);
                        },
                        function (tthis: ActualReportingComponent) {
                            handleCompletion(false);
                        }
                    );
                }
            }
        })
    }

    onClickRevoke() {
        var selectedRows = this.actualRepSelList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []
        this.customDialog.openConfirm({
            title: "Revoke KPI values",
            message: `Do you want to revoke all populated values for selected period?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                const nexusItems = selectedRows.filter(item => this.hasNexusData(item));
                const kpiItems = selectedRows.filter(item => !this.hasNexusData(item));

                const hasSelectedItems = selectedRows.length > 0;
                const shouldCallNexus = !hasSelectedItems || nexusItems.length > 0;
                const shouldCallKpi = !hasSelectedItems || kpiItems.length > 0;

                let completedCalls = 0;
                let hasFailed = false;
                const totalCalls = (shouldCallNexus ? 1 : 0) + (shouldCallKpi ? 1 : 0);

                const handleCompletion = (succeeded: boolean) => {
                    completedCalls++;
                    hasFailed = hasFailed || !succeeded;
                    if (completedCalls === totalCalls) {
                        this.loadInformation();
                        if (hasFailed) {
                            this.toastrService.error('Kpi values could not be revoked. Please, contact with administrator');
                        } else {
                            this.toastrService.success('Kpi values were revoked successfully!');
                            if (!this.hideSections())
                                this.toggleRevoke();
                        }
                    }
                };

                if (shouldCallKpi) {
                    Utils.httpRevokeKpiValues(
                        this.http,
                        this.baseUrl,
                        hasSelectedItems ? kpiItems : [],
                        { isActual: true, oplyearly: false, isBranchReporting: this.isBranchReporting() },
                        this,
                        function (tthis: ActualReportingComponent) {
                            handleCompletion(true);
                        },
                        function (tthis: ActualReportingComponent) {
                            handleCompletion(false);
                        }
                    );
                }

                if (shouldCallNexus) {
                    Utils.httpRevokeKpiNexusValues(
                        this.http,
                        this.baseUrl,
                        hasSelectedItems ? nexusItems : [],
                        this.isBranchReporting(),
                        this,
                        function (tthis: ActualReportingComponent, result: boolean) {
                            handleCompletion(result !== false);
                        },
                        function (tthis: ActualReportingComponent) {
                            handleCompletion(false);
                        }
                    );
                }
            }
        })
    }

    onClickExcelButton() {
        this.isExcelModeEnabled = true;
    }

    onClickCancelButton() {
        this.isEditModeEnabled = this.isExcelModeEnabled = false;
    }


    downloadOplInformationFromLastYear() {
        let date = new Date()
        const year = date.getFullYear().toString(); // año
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // mes con dos dígitos
        const day = date.getDate().toString().padStart(2, '0'); // día con dos dígitos
        Utils.httpDownloadMonthlyOPLInformation(
            this.http
            , this.baseUrl
            , `${year}${month}${day}_${this.defaults.managementid}_${this.defaults.groupFunction}_${this.defaults.fiscalYear - 2}-${this.defaults.fiscalYear - 1}_OPL`
            , this.isShowAllEnabled
            , this.isBranchReporting()
            , true
            , this
            , function (tthis: ActualReportingComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
            });

    }

    downloadExcelInformation() {

        let date = new Date()
        const year = date.getFullYear().toString(); // año
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // mes con dos dígitos
        const day = date.getDate().toString().padStart(2, '0'); // día con dos dígitos

        Utils.httpDownloadActualReportingInformation(
            this.http
            , this.baseUrl
            , `${year}${month}${day}_${this.defaults.managementid}_${this.defaults.groupFunction}_${this.defaults.fiscalYear - 1}-${this.defaults.fiscalYear}_P${this.defaults.period}_ACT`
            , this.isShowAllEnabled
            , this.isBranchReporting()
            , this
            , null
            , function (tthis: ActualReportingComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
            });
    }

    goUploadFileView() {
        if (!this.isBranchReporting())
            this.router.navigate(["file/" + Utils.getFileUploadActualReportingInformation()]);
        else
            this.router.navigate(["file/" + Utils.getFileUploadActualBranchReportingInformation()]);
    }

    private loadInformation(canShowReleaseMenssage: boolean = false) {
        this.updateReportingDeadlineBanner();
        this.subscriptions.forEach(x => x.unsubscribe())
        this.showReleaseLabel = false;
        this.isAllLoaded = false;
        this.updateTitle();

        if (this.hideSections())
            return;
        Utils.httpGetActualReportingInformation(
            this.http
            , this.baseUrl
            , this.isBranchReporting()
            , this
            , function (tthis: ActualReportingComponent, result: KpiManagement[]) {
                setTimeout(() => {
                    result = result.filter(x => x.KpiDetail && x.KpiDetail.length > 0)
                    result.forEach(x => {
                        x.HasNexus = x.KpiDetail.some(k => (k.NexusValue !== undefined && k.NexusValue !== null) || (k.AutomaticRestatement !== undefined && k.AutomaticRestatement !== null) || k.IsNexusKpiItem);

                        if (!x.subtable) {
                            const row = x.KpiDetail[0]
                            let maxBreakdown = ''
                            let columns = Object.assign([], tthis.columnsToDisplay2);

                            if (row.COL4 === '') {
                                columns.splice(columns.indexOf('COL4'), 1)
                                maxBreakdown = 'COL3'
                            }
                            if (row.COL3 === '') {
                                columns.splice(columns.indexOf('COL3'), 1)
                                maxBreakdown = 'COL2'
                            }
                            if (row.COL2 === '') {
                                columns.splice(columns.indexOf('COL2'), 1)
                                maxBreakdown = 'COL1'
                            }
                            if (row.COL1 === '') {
                                columns.splice(columns.indexOf('COL1'), 1)
                                maxBreakdown = 'COL0'
                            }
                            x.columns = columns
                            x.maxBreakdown = maxBreakdown
                            tthis.showReleaseLabel = tthis.showReleaseLabel || x.ApprovalStatus === 'RELEASED' || x.KpiDetail.some(detail => detail.NexusApprovalStatus === 'RELEASED');
                            //fullyReleased = fullyReleased && (x.KpiDetail.every(x => x.ApprovalStatus === '') || x.KpiDetail.every(x => x.ApprovalStatus === 'RELEASED'));
                        }
                    });
                    tthis.list = result
                    tthis.isAllLoaded = true;
                }, 50)
            }
            , function (tthis: ActualReportingComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
                tthis.list = [];
            }
        );
    }

    ////////////////
    //Filter section
    auxFilterPredicate(filters: string, data: any, parentLevel: boolean, showAllEnabled: boolean): boolean {
        if (filters === '__FORCE__') {
            return parentLevel || showAllEnabled || !!(data.ValueM1 || data.ValueM2 || data.ValueM3 || data.ValueLocal || data.Budget || data.NexusValue || data.ManualAdjustment );
        }
        const filterArray = filters.split('+').filter(x => x);
        return filterArray.every(filter => {
            if (parentLevel) {
                const kpiname = (data.KpiName || '').toLowerCase();
                const id = (data.AccountID || '').toLowerCase();
                return kpiname.includes(filter.toLowerCase()) || id.includes(filter.toLowerCase());
            } else {
                const granularity = (data.Granularity || '').toLowerCase();
                let result = granularity.includes(filter.toLowerCase());
                if (!showAllEnabled) {
                    result = result && !!(data.ValueM1 || data.ValueM2 || data.ValueM3 || data.ValueLocal || data.Budget || data.NexusValue || data.ManualAdjustment);
                }
                return result;
            }
        });
    }

    public toggleRelease() {
        this.isReleaseActive = !this.isReleaseActive;
        this.releaseButtonText = this.isReleaseActive ? 'Abort Release' : 'Initiate Release', this.actualRepSelList.clearSelectionList()
    }

    public toggleRevoke() {
        this.isRevokeActive = !this.isRevokeActive;
        this.revokeButtonText = this.isRevokeActive ? 'Abort Revoke' : 'Initiate Revoke', this.actualRepSelList.clearSelectionList()
    }
    isBranchReporting() {
        const management = Utils.GetManagementChildrenByParent(this.defaults.managementids[0], this.defaults.managementid)
        return (this.router.url.toLowerCase() === '/actualbranchreporting' && (management?.BusinessLevel === 'MANAGEMENT' && management?.Groups?.length >= 1) || management?.BusinessLevel === 'FIELDBRANCH') as boolean
    }

    hideSections() {
        const management = Utils.GetManagementChildrenByParent(this.defaults.managementids[0], this.defaults.managementid)
        return (this.router.url.toLowerCase() === '/actualbranchreporting' && management?.BusinessLevel === 'MANAGEMENT' && management?.Groups?.length >= 1) as boolean
    }

    updateReportingDeadlineBanner() {
        this.reportingDeadlineBanner = this.isBranchReporting() ?
            'Please be reminded that Data Entry / Release shall be done latest by 12th Working Date' : 
            'Please be reminded that Data Entry / Release shall be done latest by 08th Working Date as per German calendar' 
    }

    onBack() { }





    hasNexusData(item): boolean {
        // Check if the original KPI data has Nexus values
        const kpiData = this.list.find(kpi => 
            kpi.KpiDetail.some(detail => 
                detail.KpiDefinitionId === item.KpiDefinitionId &&
                detail.KpiMovementTypeId === item.KpiMovementTypeId &&
                detail.KpiProductHierarchyId === item.KpiProductHierarchyId &&
                detail.KpiBreakdown1Id === item.KpiBreakdown1Id &&
                detail.KpiBreakdown2Id === item.KpiBreakdown2Id
            )
        );
        
        if (kpiData) {
            const detail = kpiData.KpiDetail.find(d => 
                d.KpiDefinitionId === item.KpiDefinitionId &&
                d.KpiMovementTypeId === item.KpiMovementTypeId &&
                d.KpiProductHierarchyId === item.KpiProductHierarchyId &&
                d.KpiBreakdown1Id === item.KpiBreakdown1Id &&
                d.KpiBreakdown2Id === item.KpiBreakdown2Id
            );
            return detail && (detail.NexusValue !== undefined || detail.AutomaticRestatement !== undefined || detail.ManualAdjustment !== undefined);
        }
        return false;
    }

}
